module.exports = __webpack_public_path__ + "static/media/undraw_bug_fixing_oc7a.9b361370.png";